import { Enumeration } from '../../../utils/AppEnum';

export class ExpirationAction extends Enumeration<ExpirationAction> {

    public static Temporary = new ExpirationAction('Temporary', 0);

    public static Permanent = new ExpirationAction('Permanent', 1);

}
